import React from 'react';

const SectionHeader = ({ num, tag, title, color = '#F97316' }) => (
  <div style={{ marginBottom: '36px', position: 'relative' }}>
    <div
      style={{
        fontFamily: 'Impact, sans-serif',
        fontSize: 'clamp(4rem, 10vw, 8rem)',
        fontWeight: 900,
        color: `${color}08`,
        lineHeight: 1,
        position: 'absolute',
        top: '-20px',
        left: '-10px',
        userSelect: 'none',
        letterSpacing: '-0.04em'
      }}
    >
      {num}
    </div>
    <div style={{ position: 'relative', zIndex: 1 }}>
      <div
        style={{
          fontFamily: 'JetBrains Mono, monospace',
          fontSize: '0.6875rem',
          color: color,
          letterSpacing: '0.15em',
          textTransform: 'uppercase',
          marginBottom: '8px'
        }}
      >
        {tag}
      </div>
      <h2
        style={{
          fontFamily: 'Impact, sans-serif',
          fontSize: 'clamp(1.5rem, 3.5vw, 2.75rem)',
          fontWeight: 900,
          color: '#EEF0F2',
          textTransform: 'uppercase',
          letterSpacing: '-0.02em',
          lineHeight: 1
        }}
      >
        {title}
      </h2>
    </div>
  </div>
);

const BodyText = ({ children }) => (
  <p
    style={{
      fontFamily: 'Georgia, serif',
      fontSize: '1rem',
      color: 'rgba(238,240,242,0.72)',
      lineHeight: 1.85,
      marginBottom: '20px',
      maxWidth: '760px'
    }}
  >
    {children}
  </p>
);

const Divider = ({ color = '#F97316' }) => (
  <div style={{ margin: '48px 0', display: 'flex', alignItems: 'center', gap: '16px' }}>
    <div style={{ flex: 1, height: '1px', background: 'rgba(255,255,255,0.06)' }} />
    <div style={{ width: '8px', height: '8px', background: color, transform: 'rotate(45deg)' }} />
    <div style={{ flex: 1, height: '1px', background: 'rgba(255,255,255,0.06)' }} />
  </div>
);

const DisputeContactSection = () => {
  return (
    <>
      {/* Section 12: Dispute Resolution */}
      <section id="tvistelosning" style={{ marginBottom: '80px' }}>
        <SectionHeader
          num="12"
          tag="§ 12 — TVISTELØSNING & LOVVALG"
          title="Tvisteløsning & norsk jurisdiksjon"
          color="#3B6FD4"
        />
        <BodyText>
          Disse vilkårene er underlagt norsk rett. Eventuelle tvister som oppstår i forbindelse med disse vilkårene eller bruken av NordPass sine tjenester, skal søkes løst gjennom forhandlinger mellom partene.
        </BodyText>
        <div
          style={{
            background: 'rgba(59,111,212,0.08)',
            border: '2px solid rgba(59,111,212,0.25)',
            padding: '32px',
            marginBottom: '28px',
            position: 'relative',
            transform: 'rotate(0.2deg)'
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '-14px',
              left: '24px',
              background: '#3B6FD4',
              padding: '4px 12px',
              fontFamily: 'Impact, sans-serif',
              fontSize: '0.75rem',
              color: '#fff',
              letterSpacing: '0.1em'
            }}
          >
            NORSK JURISDIKSJON
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {[
              { step: '1', title: 'Direkte forhandling', desc: 'Kontakt NordPass kundeservice. Vi forsøker å løse alle tvister innen 30 dager.' },
              { step: '2', title: 'Forbrukertilsynet', desc: 'Forbrukere kan klage til Forbrukertilsynet (www.forbrukertilsynet.no) ved uenighet.' },
              { step: '3', title: 'Forbrukerrådet', desc: 'Mekling gjennom Forbrukerrådet er tilgjengelig som alternativ tvisteløsning.' },
              { step: '4', title: 'Oslo tingrett', desc: 'Dersom mekling ikke fører frem, er Oslo tingrett verneting for alle tvister.' },
            ]?.map((item, i) => (
              <div key={i} style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                <div
                  style={{
                    width: '32px',
                    height: '32px',
                    background: '#3B6FD4',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontFamily: 'Impact, sans-serif',
                    fontSize: '0.875rem',
                    color: '#fff',
                    flexShrink: 0
                  }}
                >
                  {item?.step}
                </div>
                <div>
                  <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.875rem', fontWeight: 700, color: '#EEF0F2', marginBottom: '4px' }}>{item?.title}</div>
                  <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem', color: 'rgba(138,149,163,0.8)', lineHeight: 1.6 }}>{item?.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Divider color="#3B6FD4" />

      {/* Section 13: Force Majeure */}
      <section id="force-majeure" style={{ marginBottom: '80px' }}>
        <SectionHeader
          num="13"
          tag="§ 13 — FORCE MAJEURE & SEPARABILITET"
          title="Force majeure & separabilitet"
          color="#8B5CF6"
        />
        <div
          style={{
            background: 'rgba(139,92,246,0.06)',
            border: '1px solid rgba(139,92,246,0.2)',
            borderLeft: '4px solid #8B5CF6',
            padding: '24px',
            marginBottom: '24px',
            transform: 'rotate(-0.2deg)'
          }}
        >
          <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.75rem', fontWeight: 700, color: '#8B5CF6', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '10px' }}>Force Majeure</div>
          <p style={{ fontFamily: 'Georgia, serif', fontSize: '0.9375rem', color: 'rgba(238,240,242,0.72)', lineHeight: 1.75, margin: 0 }}>
            NordPass er ikke ansvarlig for forsinkelser eller manglende oppfyllelse av forpliktelser som skyldes forhold utenfor vår rimelige kontroll, inkludert men ikke begrenset til: naturkatastrofer, krig, terrorisme, epidemier, pandemier, streik, myndighetspålegg, strømbrudd, internettavbrudd, eller andre force majeure-hendelser.
          </p>
        </div>
        <div
          style={{
            background: 'rgba(255,255,255,0.02)',
            border: '1px solid rgba(255,255,255,0.08)',
            padding: '24px',
            marginBottom: '24px'
          }}
        >
          <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.75rem', fontWeight: 700, color: '#EEF0F2', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '10px' }}>Separabilitet (Salvatorisk klausul)</div>
          <p style={{ fontFamily: 'Georgia, serif', fontSize: '0.9375rem', color: 'rgba(238,240,242,0.72)', lineHeight: 1.75, margin: 0 }}>
            Dersom en bestemmelse i disse vilkårene anses ugyldig eller ikke-håndhevbar av en kompetent domstol, skal den aktuelle bestemmelsen endres i minst mulig grad for å gjøre den gyldig og håndhevbar. De øvrige bestemmelsene i vilkårene forblir i full kraft og virkning.
          </p>
        </div>
        <BodyText>
          Disse vilkårene utgjør den fullstendige avtalen mellom deg og NordPass vedrørende bruken av tjenestene, og erstatter alle tidligere avtaler, kommunikasjon og forståelser.
        </BodyText>
      </section>

      <Divider color="#8B5CF6" />

      {/* Section 14: Legal Contact */}
      <section id="kontakt-legal" style={{ marginBottom: '80px' }}>
        <SectionHeader
          num="14"
          tag="§ 14 — JURIDISK KONTAKT"
          title="Kontakt for juridiske saker"
          color="#F97316"
        />
        <BodyText>
          For spørsmål, klager eller juridiske henvendelser vedrørende disse vilkårene, vennligst kontakt oss via følgende kanaler:
        </BodyText>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginBottom: '32px' }}>
          <div
            style={{
              background: '#0A1220',
              border: '2px solid rgba(249,115,22,0.2)',
              padding: '28px',
              position: 'relative',
              transform: 'rotate(-0.5deg)'
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: '-10px',
                left: '20px',
                background: '#F97316',
                padding: '3px 10px',
                fontFamily: 'JetBrains Mono, monospace',
                fontSize: '0.625rem',
                color: '#fff',
                letterSpacing: '0.1em'
              }}
            >
              JURIDISK AVDELING
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '8px' }}>
              {[
                { label: 'Selskap', value: 'NordPass AS' },
                { label: 'Org.nr.', value: '123 456 789' },
                { label: 'Adresse', value: 'Karl Johans gate 1, 0154 Oslo' },
                { label: 'E-post', value: 'hei@nordpassno.com' },
                { label: 'Telefon', value: '+47 20 94 89 03' },
              ]?.map((item, i) => (
                <div key={i} style={{ display: 'flex', gap: '12px' }}>
                  <span style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.6875rem', color: '#F97316', minWidth: '70px', letterSpacing: '0.05em' }}>{item?.label}:</span>
                  <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.875rem', color: 'rgba(238,240,242,0.8)' }}>{item?.value}</span>
                </div>
              ))}
            </div>
          </div>
          <div
            style={{
              background: '#0A1220',
              border: '2px solid rgba(59,111,212,0.2)',
              padding: '28px',
              position: 'relative',
              transform: 'rotate(0.3deg)'
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: '-10px',
                left: '20px',
                background: '#3B6FD4',
                padding: '3px 10px',
                fontFamily: 'JetBrains Mono, monospace',
                fontSize: '0.625rem',
                color: '#fff',
                letterSpacing: '0.1em'
              }}
            >
              RESPONSTIDER
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '8px' }}>
              {[
                { type: 'Generelle spørsmål', time: '2–3 virkedager' },
                { type: 'Juridiske klager', time: '5–10 virkedager' },
                { type: 'GDPR-forespørsler', time: '30 dager (lovpålagt)' },
                { type: 'Akutte saker', time: '24 timer (Premium)' },
              ]?.map((item, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid rgba(255,255,255,0.04)', paddingBottom: '8px' }}>
                  <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem', color: 'rgba(138,149,163,0.7)' }}>{item?.type}</span>
                  <span style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.75rem', color: '#3B6FD4' }}>{item?.time}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div
          style={{
            background: 'rgba(249,115,22,0.06)',
            border: '1px solid rgba(249,115,22,0.2)',
            padding: '20px 24px'
          }}
        >
          <p
            style={{
              fontFamily: 'Georgia, serif',
              fontStyle: 'italic',
              fontSize: '0.9375rem',
              color: 'rgba(238,240,242,0.6)',
              lineHeight: 1.7,
              margin: 0
            }}
          >
            <strong style={{ color: '#F97316', fontStyle: 'normal' }}>Sist oppdatert:</strong>{' '}
            1. februar 2026 — Versjon 1.0 — NordPass AS forbeholder seg retten til å oppdatere disse vilkårene. Vesentlige endringer varsles via e-post med 30 dagers varsel.
          </p>
        </div>
      </section>
    </>
  );
};

export default DisputeContactSection;
